<template>
  <div class="page">
    <query-form label-width="90px">
      <template v-slot:formitem>
        <query-form-item :label="$t('common.brand')">
          <el-input clearable v-model="queryForm.boutique"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.category')">
          <el-input clearable v-model="queryForm.boutique"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.boutique')">
          <el-input clearable v-model="queryForm.boutique"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.orderLineNo')">
          <el-input clearable v-model="queryForm.boutique"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.stockLocation')">
          <el-input clearable v-model="queryForm.boutique"></el-input>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb10" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <table-toolbar>
      <el-button type="primary">{{ $t('common.excel') }}</el-button>
      <el-button type="primary">{{ $t('order.confirmAllOrders') }}</el-button>
    </table-toolbar>

    <el-table class="spacing-table" v-loading="loading" :data="tableData" @selection-change="handleSelectionChange" @sort-change="sortChange">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column label="" class-name="nopadding">
        <template slot-scope="scope">
          <list-img :img="scope.row.coverImg" :width="40"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="designIdAndColorCode" label="Designer ID-Color Code" sortable="custom">
        <template slot-scope="scope"> {{ scope.row.designerId }}-{{ scope.row.colorCode }} </template>
      </el-table-column>
      <el-table-column prop="brandName" label="Brand"></el-table-column>
      <el-table-column prop="boutique" label="Boutique" sortable="custom"></el-table-column>
      <el-table-column prop="boutiqueId" label="Boutique ID" sortable="custom">
        <template slot-scope="scope">
          <router-link target="_blank" :to="{ path: '/product/' + scope.row.productId }">{{ scope.row.boutiqueId }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="seasonCode" label="Season" sortable="custom"></el-table-column>
      <el-table-column prop="category" label="Category"></el-table-column>
      <el-table-column width="100" label="Action">
        <template>
          <el-button type="text" @click="$router.push({ path: '/demo/detail' })">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import ListImg from '../../components/ListImg';
import Data from './data.json';

export default {
  name: 'List',
  components: {
    ListImg,
  },
  data() {
    return {
      loading: false,
      queryForm: {
        boutique: this.$route.query.boutique || undefined,
        pageNo: +this.$route.query.pageNo || 1,
        pageSize: +this.$route.query.pageSize || 25,
      },
      orderBy: undefined,
      desc: undefined,
      total: 0,
      tableData: [],
      selection: [],
    };
  },
  created() {
    this.getTableData(this.queryForm);
  },
  beforeRouteUpdate(to, from, next) {
    this.queryForm = {
      ...to.query,
    };
    this.getTableData(this.queryForm);
    next();
  },
  methods: {
    search() {
      this.setRouter({
        ...this.queryForm,
        pageNo: 1,
      });
    },
    reset() {
      this.queryForm.boutique = undefined;
      this.queryForm.pageNo = 1;
      this.setRouter({
        ...this.queryForm,
      });
    },
    setRouter(query) {
      this.$router.push({
        path: '/demo/list',
        query,
      });
    },
    getTableData(params) {
      params.orderBy = this.orderBy;
      params.desc = this.desc;
      this.tableData = Data.data;
      this.total = 1000;
      // this.loading = true;
      // getTableData(params).then((res) => {
      //   this.total = res.count;
      //   this.tableData = res.results;
      //   this.loading = false;
      // });
    },
    handleSizeChange(pageSize) {
      this.setRouter({
        ...this.queryForm,
        ...this.$route.query,
        pageSize,
      });
    },
    handleCurrentChange(pageNo) {
      this.setRouter({
        ...this.queryForm,
        ...this.$route.query,
        pageNo,
      });
    },
    sortChange(sort) {
      this.orderBy = sort.prop;
      this.desc = sort.order === 'ascending' ? 0 : 1;
      this.getTableData({
        ...this.$route.query,
      });
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
  },
};
</script>

<style lang="scss" scoped></style>
